var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Base = styled.g(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .visx-axis-tick text {\n    transition: all 0.3s ease-out;\n    text-anchor: ", ";\n    dominant-baseline: middle;\n  }\n"], ["\n  .visx-axis-tick text {\n    transition: all 0.3s ease-out;\n    text-anchor: ",
    ";\n    dominant-baseline: middle;\n  }\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'right'
        ? 'start'
        : orientation === 'left'
            ? 'end'
            : 'middle';
});
var templateObject_1;
//# sourceMappingURL=Axis.styles.js.map